module.exports = __webpack_public_path__ + "img/icon-school4.68f8caf3.png";